import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  message,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Upload,
} from "antd";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import {
  CaAdminLearningMenu,
  LearningRecordsAddNav,
} from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import { remainingViewportHeight } from "../../../components/icons/ApplicationColor";
import {
  BookOutlined,
  InfoCircleTwoTone,
  UserOutlined,
  ContainerOutlined,
  InboxOutlined,
  RetweetOutlined,
  SaveOutlined,
  BackwardOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import "./RecordAddStyles.css";
import axiosInstance from "../../../api/Axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs"; // optional, for formatting
import { uploadFileCourse } from "./courseUtils";
import { useNavigate } from "react-router-dom";
const { Title, Paragraph, Text } = Typography;
const today = dayjs().format("MMM DD YYYY");
const { Dragger } = Upload;

const LearningRecordsAdd = () => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const userInfo = useSelector((state) => state.user);
  const history = useNavigate();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");
  const [certifcate, setCertificate] = useState("");
  const [proof, setProof] = useState("");
  const [attachments, setAttachments] = useState([]);
  const handleUpload = async (file, type) => {
    const file_name = await uploadFileCourse(file, "learning", csrfToken);
    if (type === "certificate") {
      setCertificate(file_name);
    } else if (type === "proof") {
      setProof(file_name);
    } else if (type === "attachment") {
      setAttachments((prev) => [...prev, { file_name }]);
    }
  };

  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const payload = {
      user: normalizedValues?.first_name,
      course: normalizedValues?.name,
      mode: normalizedValues?.mode,
      start_date: normalizedValues?.start_date
        ? dayjs(normalizedValues.start_date).format("MMM DD YYYY")
        : "",
      end_date: normalizedValues?.end_date
        ? dayjs(normalizedValues.end_date).format("MMM DD YYYY")
        : "",
      expiry_by: normalizedValues?.expiry_by
        ? dayjs(normalizedValues.expiry_by).format("MMM DD YYYY")
        : "",
      organization: userInfo?.data?.organization.id,
      certificate: certifcate,
      attendance_proof: proof,
      external_trainer: normalizedValues?.external_trainer,
      external_location: normalizedValues?.external_location,
      is_manual_entry: true,
      attachment: attachments,
    };
    console.log("Form Values:", payload);
    try {
      await axiosInstance.post(`/learningrecordcreate/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      CreateSuccessfull();
    } catch (err) {
      CreateFailed();
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Learning Record creation success.",
      duration: 5,
    });
    setTimeout(() => {
      history(`/ca-admin/trainery-learn/records/listing`);
    }, 2000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Record Creation failure",
      duration: 5,
    });
  };
  const [showMore, setShowMore] = useState(false);
  const [data2, setData2] = useState([]);
  const [filterData2, setFilterData2] = useState({
    pageSize2: 15,
    currentPage2: 1,
    url2: `/user/?organization=${userInfo.data.organization.id}&organization_user_archived=False`,
    search2: "",
    filter_url2: "",
  });
  const { pageSize2, currentPage2, url2, search2, filter_url2 } = filterData2;
  const LoadUser2 = async () => {
    let passUrl = url2;
    let doNothing = false;
    if (search2?.length > 0) {
      if (search2.length > 1) {
        passUrl += `&page_num=${currentPage2}&items=${pageSize2}&search=${search2}${filter_url2}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page_num=${currentPage2}&items=${pageSize2}${filter_url2}`;
    }
    if (!doNothing) {
      try {
        const res = await axiosInstance.get(passUrl);
        setData2(res?.data?.data?.User_data || []);

        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const handleSearchChange2 = (event) => {
    setFilterData2((prevData) => ({
      ...prevData,
      search2: event.target.value,
      currentPage2: 1,
    }));
  };
  useEffect(() => {
    LoadUser2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData2]);
  const handleUserChange = (id) => {
    const selectedUser = data2.find((user) => user.id === id);

    if (selectedUser) {
      form.setFieldsValue({
        user: selectedUser.id,
        first_name: selectedUser.id,
        last_name: selectedUser.last_name,
        email: selectedUser.email,
        location: selectedUser.organization?.location,
        job_title: selectedUser.job_title,
        entity: selectedUser.organization?.entity?.entity_name,
        division: selectedUser.organization?.division?.div_name,
        department: selectedUser.organization?.department?.dep_name,
      });
    }
  };

  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/courselist/?organization=${userInfo?.data?.organization?.id}`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, search, active, filter_url } = filterData;
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `&page=${currentPage}&page_size=${pageSize}&search=${search}&status=${
          active ? "True" : "False"
        }&${filter_url}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page=${currentPage}&page_size=${pageSize}&status=${
        active ? "True" : "False"
      }&${filter_url}`;
    }
    if (!doNothing) {
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res.data.results);

        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const handleCourseChange = (id) => {
    const selectedCourse = data.find((course) => course.id === id);

    if (selectedCourse) {
      form.setFieldsValue({
        course: selectedCourse.id,
        name: selectedCourse.id,
        course_id: selectedCourse.course_id,
        language: selectedCourse.language,
        mode: selectedCourse.mode,
      });
    }
  };

  return (
    <CaSideNav props={CaAdminLearningMenu}>
      {contextHolder}
      <SecondaryNav menuItems={LearningRecordsAddNav} />
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(14),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
        }}
      >
        <Card
          style={{
            width: "70%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: "10px",
          }}
          hoverable
        >
          <Title level={4}>Manual Learning Record Entry</Title>
          <Paragraph type="secondary">
            Add learning records manually by entering the details below.
          </Paragraph>

          <Form layout="vertical" onFinish={handleSubmit} form={form}>
            {/* ✅ Box: Basic Details */}

            <Card
              size="small"
              style={{
                marginBottom: 24,
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fafafa",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              }}
              bodyStyle={{ padding: "20px 24px" }}
            >
              <div
                style={{
                  // marginBottom: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <InfoCircleTwoTone
                  style={{ fontSize: "18px", color: "#1890ff" }}
                />
                <Title level={5} style={{ margin: 0 }}>
                  Basic Details
                </Title>
              </div>
              <Divider
                style={{
                  padding: 0,
                  margin: 0,
                  marginTop: 10,
                  marginBottom: 15,
                }}
              />
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Text type="secondary">Created At</Text>
                  <Input
                    readOnly
                    value={today}
                    style={{ cursor: "not-allowed" }}
                  />
                </Col>
                <Col span={8}>
                  <Text type="secondary">Created By</Text>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background: "#fff",
                      padding: "3px 12px",
                      borderRadius: "6px",
                      border: "1px solid #d9d9d9",
                    }}
                  >
                    <Avatar
                      size="small"
                      src={userInfo?.data?.profile_pic || undefined}
                      icon={!userInfo?.data?.profile_pic && <UserOutlined />}
                      style={{ marginRight: 10 }}
                    />
                    <Text type="secondary">{userInfo?.data?.full_name}</Text>
                  </div>
                </Col>
                <Col span={8}>
                  <Form.Item
                    className="nospace"
                    label={
                      <Text type="secondary" style={{ padding: "0px" }}>
                        Expiry Date
                      </Text>
                    }
                    name="expiry_by"
                  >
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* ✅ Box: User Details */}
            <Card
              size="small"
              style={{
                marginBottom: 24,
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fafafa",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              }}
              bodyStyle={{ padding: "20px 24px" }}
            >
              <div
                style={{
                  // marginBottom: 15,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <UserOutlined
                    style={{ fontSize: "18px", color: "#722ed1" }}
                  />
                  <Title level={5} style={{ margin: 0 }}>
                    User Details
                  </Title>
                </div>
                <div style={{ textAlign: "right", marginTop: 0 }}>
                  <Button
                    type="link"
                    icon={showMore ? <UpOutlined /> : <DownOutlined />}
                    onClick={() => setShowMore((prev) => !prev)}
                    style={{
                      fontWeight: 500,
                      paddingInline: 0,
                      fontSize: 13,
                      color: "#722ed1",
                    }}
                  >
                    {showMore ? "Show Less" : "Show More"}
                  </Button>
                </div>
              </div>
              <Divider
                style={{
                  padding: 0,
                  margin: 0,
                  marginTop: 10,
                  marginBottom: 15,
                }}
              />
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="First Name"
                    name="first_name"
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      placeholder="Select First Name"
                      onSearch={(value) =>
                        handleSearchChange2({ target: { value } })
                      }
                      onChange={(value) => handleUserChange(value)}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      options={data2.map((u) => ({
                        label: u.first_name,
                        value: u.id,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    label="Last Name"
                    name="last_name"
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Last Name"
                      onSearch={(value) =>
                        handleSearchChange2({ target: { value } })
                      }
                      onChange={(value) => handleUserChange(value)}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      options={data2.map((u) => ({
                        label: u.last_name,
                        value: u.id,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col span={7}>
                  <Form.Item label="Email" name="email">
                    <Select
                      showSearch
                      placeholder="Select Email"
                      onSearch={(value) =>
                        handleSearchChange2({ target: { value } })
                      }
                      onChange={(value) => handleUserChange(value)}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      options={data2.map((u) => ({
                        label: u.email,
                        value: u.id,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col span={5}>
                  <Form.Item label="Location" name="location">
                    <Input
                      placeholder="Location"
                      readOnly
                      style={{ cursor: "not-allowed" }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {showMore && (
                <Row gutter={24} style={{ transition: "all 0.3s ease" }}>
                  <Col span={6}>
                    <Form.Item label="Work Role" name="job_title">
                      <Input
                        placeholder="Work Role"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Entity" name="entity">
                      <Input
                        placeholder="Entity"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Division" name="division">
                      <Input
                        placeholder="Division"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Department" name="department">
                      <Input
                        placeholder="Department"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Card>
            <Card
              size="small"
              style={{
                marginBottom: 24,
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fdfdfd",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              }}
              bodyStyle={{ padding: "20px 24px" }}
            >
              <div
                style={{
                  // marginBottom: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <BookOutlined style={{ fontSize: "18px", color: "#722ed1" }} />
                <Title level={5} style={{ margin: 0 }}>
                  Course Details
                </Title>
              </div>
              <Divider
                style={{
                  padding: 0,
                  margin: 0,
                  marginTop: 10,
                  marginBottom: 15,
                }}
              />
              <Row gutter={24}>
                <Col span={7}>
                  <Form.Item
                    label="Program Name"
                    name="name"
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Course Name"
                      onSearch={(value) =>
                        handleSearchChange({ target: { value } })
                      }
                      onChange={handleCourseChange} // now just use the course.id
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      options={data.map((course) => ({
                        label: course.name,
                        value: course.id,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col span={7}>
                  <Form.Item
                    label="Program ID"
                    name="course_id"
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      placeholder="Select ID"
                      onSearch={(value) =>
                        handleSearchChange({ target: { value } })
                      }
                      onChange={handleCourseChange} // still using course.id
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      options={data.map((course) => ({
                        label: course.course_id,
                        value: course.id,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col span={5}>
                  <Form.Item label="Mode" name="mode">
                    <Input
                      placeholder="Course mode"
                      readOnly
                      style={{ cursor: "not-allowed" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item label="Language" name="language">
                    <Input
                      placeholder="language"
                      readOnly
                      style={{ cursor: "not-allowed" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={7}>
                  <Form.Item label="Trainer Name" name="external_trainer">
                    <Input placeholder="Enter Trainer Name" />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item label="Training Location" name="external_location">
                    <Input placeholder="Enter Training Location" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            {/* ✅ Box: Event Details */}
            <Card
              size="small"
              style={{
                marginBottom: 24,
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fafafa",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              }}
              bodyStyle={{ padding: "20px 24px" }}
            >
              <div
                style={{
                  // marginBottom: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <ContainerOutlined
                  style={{ fontSize: "18px", color: "#1890ff" }}
                />
                <Title level={5} style={{ margin: 0 }}>
                  Event Details
                </Title>
              </div>
              <Divider
                style={{
                  padding: 0,
                  margin: 0,
                  marginTop: 10,
                  marginBottom: 15,
                }}
              />
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item label="Event Name" name="source">
                    <Input placeholder="Enter Event Source" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Start Date"
                    name="start_date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="End Date" name="end_date">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item
                    label="Training Certificate"
                    name="certificate"
                    style={{ width: "100%", marginBottom: 0 }}
                    className="proof-attendance-form-item"
                  >
                    <Upload
                      beforeUpload={() => false}
                      showUploadList={true}
                      onChange={(info) => {
                        const file = info.file.originFileObj || info.file;
                        if (file) {
                          handleUpload(file, "certificate");
                        }
                      }}
                      className="proof-attendance-upload"
                    >
                      <Button
                        style={{ width: "100%", display: "block" }}
                        type="dashed"
                        className="proof-attendance-btn"
                      >
                        Upload Certificate
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    label="Proof of Attendance"
                    name="attendanceProof"
                    style={{ width: "100%", marginBottom: 0 }}
                    className="proof-attendance-form-item"
                  >
                    <Upload
                      beforeUpload={() => false}
                      showUploadList={true}
                      onChange={(info) => {
                        const file = info.file.originFileObj || info.file;
                        if (file) {
                          handleUpload(file, "proof");
                        }
                      }}
                      style={{ width: "100%", display: "block" }}
                      className="proof-attendance-upload"
                    >
                      <Button
                        style={{ width: "100%", display: "block" }}
                        type="dashed"
                        className="proof-attendance-btn"
                      >
                        Upload Proof
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              size="small"
              style={{
                marginBottom: 24,
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fdfdfd",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                width: "100%",
              }}
              bodyStyle={{ padding: "20px 24px" }}
            >
              <div
                style={{
                  marginBottom: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <InboxOutlined style={{ fontSize: "18px", color: "#1890ff" }} />
                <Title level={5} style={{ margin: 0 }}>
                  Attachments
                </Title>
              </div>
              <Form.Item
                name="attachments"
                valuePropName="fileList"
                getValueFromEvent={(e) =>
                  Array.isArray(e) ? e : e && e.fileList
                }
              >
                <Dragger
                  name="files"
                  multiple
                  style={{ width: "100%" }}
                  beforeUpload={() => false}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif,.bmp,.svg,.zip"
                  showUploadList={true} // hide default list since we show our own
                  onChange={(info) => {
                    if (info.file.status !== "removed") {
                      const latestFile =
                        info.fileList[info.fileList.length - 1];
                      if (latestFile) {
                        const actualFile =
                          latestFile.originFileObj || latestFile;
                        if (actualFile) {
                          handleUpload(actualFile, "attachment");
                        }
                      }
                    }
                  }}
                  onRemove={(file) => {
                    setAttachments((prev) =>
                      prev.filter(
                        (att) => !att.file_name.includes(file.name) // check by matching filename
                      )
                    );
                  }}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag files to this area to upload
                  </p>
                  <p className="ant-upload-hint">
                    Upload any supporting documents, certificates, or other
                    files related to this learning record. You can upload
                    multiple files at once.
                  </p>
                </Dragger>
              </Form.Item>
            </Card>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 16,
                marginTop: 24,
              }}
            >
              <div>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    // onClick={() => {
                    //   history("/ca-admin/trainery-learn/courses/listing");
                    // }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="save-update-btn"
                    // disabled
                  >
                    Save
                    <SaveOutlined />
                  </Button>
                </Form.Item>
              </div>
              <div>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    // onClick={handleReset}
                    style={{
                      background: "#D3D3D3",
                    }}
                  >
                    Reset
                    <RetweetOutlined />
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </CaSideNav>
  );
};

export default LearningRecordsAdd;
